/**
 *    Result item
 */

(function ($) {
  Drupal.behaviors.resultItem = {
    attach(context, settings) {
      const dateSaveButton = function () {
        $(document.body).on('click', '.vb-button--save-date', function () {
          $(this).toggleClass('vb-active');
        });
      };

      const tagFilter = function () {
        const $targetContainer = $('.vb-header-filter__tags');

        $('.vb-result-item__tags .vb-tags__link ').on('click', function (e) {
          e.preventDefault();

          const $button = $(this);
          const $targetInput = $targetContainer.find(`label:contains(${$button.text()})`).prev('input');

          // toggle checkbox
          if ($targetInput.is(':checked')) {
            $targetInput.removeAttr('checked').change();
          } else {
            $targetInput.attr('checked', 'checked').change();
          }
        });
      };

      // tag filter
      tagFilter();

      // date save button
      dateSaveButton();
    },
  };
}(jQuery));

// end of result-item.js
